import { ReactElement, ReactNode } from 'react';
import { Loading } from '@e2m-customer-portal/ui';
import { ErrorComponent } from '../error-component/ErrorComponent';

export interface LoadingErrorProps {
  /**
   * Additional class name to apply to this component. Only effective while loading or in error state.
   */
  className?: string;

  /**
   * Set if the call is currently loading. Takes precedence over `children`.
   */
  loading?: boolean;

  /**
   * Set if the call errored. Takes precedence over both `loading` and `children`.
   */
  error?: string | Error;

  /**
   * If set, will be prefixed before a possible error message.
   */
  errorPrefix?: string;

  /**
   * Gets displayed if both `loading` and `error` are falsy.
   */
  children?: ReactNode;
}

export function LoadingError({
  className,
  loading,
  error,
  errorPrefix,
  children,
}: Readonly<LoadingErrorProps>): ReactElement<LoadingErrorProps> {
  if (error) {
    return <ErrorComponent className={className} error={error} errorPrefix={errorPrefix} />;
  }

  if (loading) {
    return <Loading />;
  }

  return <>{children}</>;
}
